import React from 'react';
import { Play, Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Sophia',
    location: 'South Australia',
    text: "Transformed my daily routine. It's so easy to use. The adjustable heat settings are great for my clients with different hair types.",
    rating: 5,
    avatar: 'S'
  },
  {
    name: 'Jamie',
    location: 'Melbourne',
    text: "Perfect Pass is the best investment I've made for my hair care. It's versatile and perfect for both professional and personal use.",
    rating: 5,
    avatar: 'J'
  },
  {
    name: 'Jenny',
    location: 'Queensland',
    text: "Finally, a keratin iron that thinks for me! The Perfect Pass makes keratin treatments so simple, and the results are always stunning.",
    rating: 5,
    avatar: 'J'
  },
  {
    name: 'Emily',
    location: 'Melbourne CBD',
    text: "This keratin straightener really delivers on its promises. The pass counting technology makes my job easier, and my clients love how their hair looks.",
    rating: 5,
    avatar: 'E'
  }
];

export const Testimonials = () => {
  return (
    <section className="section bg-[#0a0518] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-purple-600/20 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-fuchsia-600/10 rounded-full blur-3xl" />
      </div>
      
      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="text-purple-400 text-sm font-semibold uppercase tracking-wider mb-4 block">
            Happy Customers
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            What Hairdressers Are <span className="text-gradient italic">Saying</span>
          </h2>
          <p className="text-purple-200 text-lg max-w-2xl mx-auto">
            See why professionals across Australia choose the Perfect Pass keratin iron for their salons.
          </p>
        </div>

        {/* Video Testimonial - Featured */}
        <div className="max-w-4xl mx-auto mb-16 animate-fade-in-up" id="testimonials">
          <div className="glass-card overflow-hidden">
            <div className="relative aspect-video bg-black rounded-t-xl overflow-hidden">
              <video
                controls
                className="w-full h-full object-cover"
                poster="https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/awleu9gc_DSC04270.jpg"
                preload="metadata"
                title="Winamor Perfect Pass Keratin Iron - Professional Hairdresser Review Australia"
                aria-label="Video testimonial from professional hairdresser about Winamor Perfect Pass keratin straightener"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/6dlwh1m7_Winamor4%20%281%29%20%281%29.mp4" 
                  type="video/mp4" 
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-4 mb-3">
                <div className="flex" aria-label="5 star rating">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <span className="text-purple-300 text-sm">Professional Testimonial</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                "The Best Keratin Iron I've Ever Used" - Professional Hairdresser Review
              </h3>
              <p className="text-purple-300">
                Watch how the Winamor Perfect Pass keratin straightener with pass counting technology 
                has transformed hair styling for professional hairdressers across Australia. See real results 
                from keratin treatments using our precision iron.
              </p>
            </div>
          </div>
        </div>

        {/* Written Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="testimonial-card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-purple-500/30 mb-4" />
              
              {/* Rating */}
              <div className="star-rating mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="star w-5 h-5 fill-yellow-400" />
                ))}
              </div>
              
              {/* Text */}
              <p className="text-purple-100 mb-6 italic">"{testimonial.text}"</p>
              
              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-purple-500/30 flex items-center justify-center">
                  <span className="text-white font-bold">{testimonial.avatar}</span>
                </div>
                <div>
                  <div className="text-white font-semibold">{testimonial.name}</div>
                  <div className="text-purple-400 text-sm">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
